import { Globe2 } from "lucide-react";

const PHONES = [
  { code: "en", label: "English", img: "/screenshots/lang_en.png" },
  { code: "fr", label: "Français", img: "/screenshots/lang_fr.png" },
  { code: "hi", label: "हिन्दी", img: "/screenshots/lang_hi.png" },
  { code: "es", label: "Español", img: "/screenshots/lang_es.png" },
];

const MORE_LANGUAGES = ["বাংলা", "தமிழ்", "తెలుగు", "ಕನ್ನಡ", "മലയാളം", "ਪੰਜਾਬੀ", "ଓଡ଼ିଆ"];

export function LanguageShowcase() {
  return (
    <section className="px-6 py-20 bg-white" data-testid="section-language-showcase">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#4F46E5] bg-[#4F46E5]/10 px-3 py-1.5 rounded-full mb-5">
            <Globe2 className="w-3.5 h-3.5" /> 11 languages supported
          </span>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-3">Breaking the language barriers</h2>
          <p className="text-slate-600 max-w-xl mx-auto">
            One tap on the language icon and the same poll — question and options — instantly appears in a participant's own language, live and in real time.
          </p>
          <p className="text-slate-400 text-xs max-w-xl mx-auto mt-3" data-testid="language-connectivity-disclaimer">
            Live translation runs over the network — speed and accuracy may vary if your internet connection is slow or unstable.
          </p>
        </div>

        <div className="flex flex-wrap items-start justify-center gap-6 sm:gap-8 mb-10">
          {PHONES.map((p) => (
            <div key={p.code} className="flex flex-col items-center gap-3" data-testid={`language-showcase-phone-${p.code}`}>
              <div className="w-[150px] sm:w-[170px] rounded-[1.6rem] border-[5px] border-slate-900 bg-slate-900 shadow-2xl shadow-slate-300 overflow-hidden">
                <img src={p.img} alt={`Live poll shown in ${p.label}`} className="w-full block" />
              </div>
              <span className="text-xs font-semibold text-slate-500">{p.label}</span>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2.5" data-testid="language-showcase-more-chips">
          {MORE_LANGUAGES.map((l) => (
            <span key={l} className="text-sm font-semibold text-slate-600 bg-[#FAFAFC] border border-slate-200 rounded-full px-4 py-1.5">
              {l}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
